import { render, staticRenderFns } from "./WithdrawalHistory.vue?vue&type=template&id=8ba955a8"
import script from "./WithdrawalHistory.vue?vue&type=script&lang=js"
export * from "./WithdrawalHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports